import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { toast } from 'react-toastify'
import { cancelTransactionRequest, cancelTransactionSuccess, cancelTransactionFailure } from '../actions'
import { RootEpic } from '../types'

export const cancelTransactionEpic: RootEpic = (action$, state$, { cancelTransaction }) => {
  return action$.pipe(
    filter(isActionOf(cancelTransactionRequest)),
    exhaustMap(({ payload }) =>
      from(
        cancelTransaction({
          token: state$.value.app.authToken || '',
          transactionId: payload as string,
        }),
      ).pipe(
        map((response) => {
          toast.success('Transaction cancelled successfully.')
          return cancelTransactionSuccess(response)
        }),
        catchError((message) => {
          toast.error(message || 'Failed to cancel transaction.')
          return of(cancelTransactionFailure(message))
        }),
      ),
    ),
  )
}

export default [cancelTransactionEpic]
